import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { readApiErrorMessage } from '../../../../../utils/commonServices';
import { updateVoiceState } from '../../../../../redux/voiceSlice';
import { updatePendingCallState } from '../../../../../redux/pendingCallSlice';
import { setSnackbar } from '../../../../../redux/messageSlice';
import { synthesizeVoApi } from '../../../../../services/api';

export default ()=> {
    const [audioUrl, setAudioUrl] = useState('');
    // const [sampleUrl, setSampleUrl] = useState('');
    // const [isSample, setIsSample] = useState(true)
    // const [voices, setVoices] = useState([]);
    // const [selectedVoice, setSelectedVoice] = useState('');
    // const [isSpeaking, setIsSpeaking] = useState(false);
    // const [styleList, setStyleList] = useState([]);
    // const [style, setStyle] = useState();
    // const [playbackRate, setPlaybackRate] = useState(1.0); // Default playback rate
    const sampleRef = useRef(null);
    const contentReducer = useSelector((state) => state.contentReducer)
    const voiceReducer = useSelector((state) => state.voiceReducer)
    const dropdownReducer = useSelector((state) => state.persistedReducers.dropdownReducer)
    const dispatch = useDispatch();

    const handleGenerateVoiceSample = async () => {
      dispatch(updatePendingCallState({voice_sample: true}))
      if (sampleRef.current) {
        sampleRef.current.pause();
        sampleRef.current.src = ''; // Clear the current audio source
      }
      
      dispatch(updateVoiceState({is_generating_sample: true}))
     // setIsSpeaking(true);

      const body = {
        voice: voiceReducer?.selected_voice?.ShortName,
        style: voiceReducer?.selected_style && voiceReducer?.selected_style !== 'default' ? voiceReducer?.selected_style : null,
        accent: voiceReducer?.selected_accent || 'en-US',
        pitch: Math.round(Number(voiceReducer?.pitch)) || 0,
        rate: Math.round(Number(voiceReducer?.rate)) || 0,
        text: voiceReducer?.sample_text,
      };

      try {
        const response = await synthesizeVoApi(body);
        const audioBlob = response.data;
        const url = URL.createObjectURL(audioBlob);
        dispatch(updateVoiceState({sample_url: url}))
        dispatch(updatePendingCallState({voice_sample: false}))
      } catch (error) {
        dispatch(updatePendingCallState({voice_sample: false}))
        const detail = await readApiErrorMessage(error);
        dispatch(setSnackbar({type:'error', flag:true, message: detail || 'Oops! Something went wrong. Try another voice or contact support.'}))
        console.error('Error synthesizing speech:', error);
      }
      dispatch(updateVoiceState({is_generating_sample: false}))
    };

    // useEffect(()=> {
    //     if(!!selectedVoice?.styleList) {
    //         setStyleList(selectedVoice?.styleList)
    //     }
    // }, [selectedVoice])
  
    useEffect(() => {
      if (!!voiceReducer?.sample_url && sampleRef.current) {
        sampleRef.current.src = voiceReducer?.sample_url;
        playSample();
      }
    }, [voiceReducer?.sample_url]);
  
    const playSample = () => {
      if (!!sampleRef.current) {
        try {
          sampleRef.current.play().catch(error => {
            if (error.name === 'AbortError') {
            } else {
              console.error('Error playing sample:', error);
            }
          });
          dispatch(updateVoiceState({is_sample_playing: true}))
        } catch (error) {
          console.error('Error playing sample:', error);
        }
      }
    };
  
    // const pauseSample = () => {
    //   sampleRef.current.pause();
    // };
    const pauseSample = () => {
      if (!!sampleRef.current) {
        try {
          sampleRef.current.pause();
          dispatch(updateVoiceState({is_sample_playing: false}))
        } catch (error) {
          console.error('Error pausing sample:', error);
        }
      }
    };
  
    // const handleSeek = (event) => {
    //   audioRef.current.currentTime = event.target.value;
    // };
  
    // const handlePlaybackRateChange = (event) => {
    //   const rate = parseFloat(event.target.value);
    //  // setPlaybackRate(rate);
    //   if (audioRef.current) {
    //     audioRef.current.playbackRate = rate;
    //   }
    // };
  
    // const handleDownload = () => {
    //   const link = document.createElement('a');
    //   link.href = audioUrl;
    //   link.download = 'speech.wav';
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // };
  return {
          sampleRef, 
          playSample, 
          pauseSample,
          handleGenerateVoiceSample, 
        }
}
